import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

import { ActionButton } from "../../components";
import VideoUploaderView from "../../extensions/VideoUpload/components/VideoUploaderView";

export const VideoUpload = Node.create({
	name: "videoUpload",
	isolating: true,
	defining: true,
	group: "block",
	draggable: true,
	selectable: true,
	inline: false,
	parseHTML() {
		return [
			{
				tag: `div[data-type="${this.name}"]`
			}
		];
	},
	renderHTML() {
		return ["div", { "data-type": this.name }];
	},

	addCommands() {
		return {
			setVideoUpload:
				() =>
				({ commands }) =>
					commands.insertContent(`<div data-type="${this.name}"></div>`)
		};
	},
	addNodeView() {
		return ReactNodeViewRenderer(VideoUploaderView);
	},
	addOptions() {
		return {
			...this.parent?.(),
			upload: undefined,
			button: ({ editor, t }) => {
				return {
					component: ActionButton,
					componentProps: {
						action: () => editor.commands.setVideoUpload(),
						isActive: () => editor.isActive("video") || false,
						icon: "Video",
						tooltip: t("editor.video.tooltip")
					}
				};
			}
		};
	}
});

export default VideoUpload;
